import React from 'react';
import CodeIcon from '@mui/icons-material/Code';
import CropSquareIcon from '@mui/icons-material/CropSquare';
import HtmlIcon from '@mui/icons-material/Html';
import LanguageIcon from '@mui/icons-material/Language';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import StorefrontIcon from '@mui/icons-material/Storefront';
import WebAssetIcon from '@mui/icons-material/WebAsset';
import noCodeData from '../../data/getStartedNoCodeOptions.json';

export type NoCodePlatformOption = {
  id: string;
  name: string;
};

export type NoCodePlatformVisual = {
  icon: React.ReactElement;
  tint: string;
  ink: string;
};

export const NO_CODE_PLATFORM_VISUALS: Record<string, NoCodePlatformVisual> = {
  wordpress: { icon: <LanguageIcon />, tint: '#DBEAFE', ink: '#1D4ED8' },
  html: { icon: <HtmlIcon />, tint: '#FFEDD5', ink: '#C2410C' },
  shopify: { icon: <ShoppingBagIcon />, tint: '#DCFCE7', ink: '#047857' },
  webflow: { icon: <WebAssetIcon />, tint: '#E0E7FF', ink: '#4338CA' },
  wix: { icon: <StorefrontIcon />, tint: '#F3E8FF', ink: '#6B21A8' },
  squarespace: { icon: <CropSquareIcon />, tint: '#E2E8F0', ink: '#0F172A' },
  others: { icon: <CodeIcon />, tint: '#F1F5F9', ink: '#334155' },
};

export const getNoCodePlatformOptions = (): NoCodePlatformOption[] =>
  ((noCodeData.options || []) as NoCodePlatformOption[]).map(({ id, name }) => ({ id, name }));

export const getNoCodePlatformVisual = (id: string): NoCodePlatformVisual =>
  NO_CODE_PLATFORM_VISUALS[id] || NO_CODE_PLATFORM_VISUALS.others;

export const matchNoCodePlatformId = (
  platformNameOrId?: string,
  options: NoCodePlatformOption[] = getNoCodePlatformOptions()
): string => {
  if (!platformNameOrId) return options[0]?.id || 'wordpress';
  const needle = platformNameOrId.trim().toLowerCase();
  const byId = options.find((opt) => opt.id.toLowerCase() === needle);
  if (byId) return byId.id;
  const byName = options.find((opt) => opt.name.toLowerCase() === needle);
  if (byName) return byName.id;
  return options[0]?.id || 'wordpress';
};
